import { initializeApp, getApps, getApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

const isTestEnv = process.env.NODE_ENV === 'test';

function getConfigValue(value, fallback = '') {
  if (value) {
    return value;
  }

  return isTestEnv ? fallback : '';
}

const firebaseConfig = {
  apiKey: getConfigValue(process.env.REACT_APP_FIREBASE_API_KEY, 'test-api-key'),
  authDomain: getConfigValue(process.env.REACT_APP_FIREBASE_AUTH_DOMAIN, 'test.firebaseapp.com'),
  projectId: getConfigValue(process.env.REACT_APP_FIREBASE_PROJECT_ID, 'test-project'),
  storageBucket: getConfigValue(process.env.REACT_APP_FIREBASE_STORAGE_BUCKET, 'test.appspot.com'),
  messagingSenderId: getConfigValue(process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID, '1234567890'),
  appId: getConfigValue(process.env.REACT_APP_FIREBASE_APP_ID, '1:1234567890:web:test'),
};

const hasRequiredConfig = [
  firebaseConfig.apiKey,
  firebaseConfig.authDomain,
  firebaseConfig.projectId,
  firebaseConfig.appId,
].every(Boolean);

if (!hasRequiredConfig) {
  console.warn('Firebase config is incomplete. Set REACT_APP_FIREBASE_* variables.');
}

const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
